import React, { useEffect } from 'react'
import { Typography } from '@material-tailwind/react';
import Banner from '../Components/banner/Banner';
import BannerData from '../models/BannersData';
import PackagesData from '../models/PackagesHomeData';
import PackagesCard from '../Components/card/PackageCard';
import SubFooterBar from '../Components/common/SubFooterBar';
import TitleComponent from '../Components/common/TitleComponent';
import BreadcrumbsComponent from '../Components/common/BreadcrumbsComponent';
import Masonry from 'react-masonry-css';

const PackagesPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const BreadCrumbsPath = [
        {
            id: 1,
            pathName: "Our Packages",
            pathLink: "/Packages",
        },
    ];

    const breakpointColumnsObj = {
        default: 3,
        1100: 2,
        700: 1,
    };

    return (
        <>

            {BannerData.filter(item => item.title === 'Packages').map((item) => (
                <Banner key={item.id} bannerDetails={item} />
            ))}

            <BreadcrumbsComponent fullWidth BreadCrumbsPath={BreadCrumbsPath} />

            <TitleComponent Title={"Our Packages"} Subtitle={"Checkout our Special Treatment Packages"} />

            <div className="my-5 px-5 md:px-12 lg:px-24">
                <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="flex -ml-5"
                    columnClassName="pl-5"
                >
                    {PackagesData.map((item, index) => (
                        <div key={index} className='py-5'>
                            <PackagesCard key={item.id} PackagesDetails={item} />
                        </div>
                    ))}
                </Masonry>
            </div>

            {/* *********************** ORIGINAL CODE *********************** */}

            {/* <div className='my-5 px-5 md:px-12 lg:px-24 grid gap-5 grid-cols-1 md:grid-cols-2 lg:grid-cols-3'>
                {PackagesData.map((item) => (
                    <PackagesCard key={item.id} PackagesDetails={item} />
                ))}
            </div> */}

            {/* *********************** ORIGINAL CODE *********************** */}

            <SubFooterBar />
        </>
    )
}

export default PackagesPage